import React, {useState, useEffect} from "react";
import {useParams, useHistory, Link} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import { RadioButton } from 'primereact/radiobutton';

// service
import {ChequeCultureLegacy} from "../../legacyforms/ChequeCultureLegacy";
import {setASExercice, setCAS, setListActionSociale} from "../../../store/actions/actionSociale";
import {ActionSocialeService} from "../../../service/ActionSocialeService";
import { LinkProviderService } from "../../../service/LinkProviderService";

// actions
import { getUsagerInfo } from "../../../store/actions/usager";

// scss
import "../clap/FormulaireClap.scss";

export const ChoixPeriodeVacances = () => {
    const { codeCas } = useParams();
    const dispatch = useDispatch();
    const history = useHistory();
    const [exerciceslist, setExercicesList] = useState([]);
    const actionSociale = useSelector((state) => state.actionSociale);
    const [listActionSociales, setListActionSociales] = useState([]);
    const [selectedExercice, setSelectedExercice] = useState(null);
    const [skip, setSkip] = useState(false);
    const [loadInit, setLoadInit] = useState(false);
    const [displayBasic, setDisplayBasic] = useState(false);

    const actionSocialeService = new ActionSocialeService();

    const linkService = new LinkProviderService();



    useEffect(() => {
        callUsagerInfoApi()
    }, []);

    useEffect(() => {
        dispatch(setCAS(codeCas));
        dispatch(setASExercice(selectedExercice));
        dispatch(setListActionSociale(listActionSociales));
    }, [selectedExercice]);


    useEffect(() => {
           initData();
        }, [loadInit]);


    useEffect(() => {
        if(skip) {
            actionSocialeService.persistState(actionSociale);
            history.push("/vacances/create");
        }
    },[skip]);

    const callUsagerInfoApi = () => {
        dispatch(getUsagerInfo()).then((res) => {
          if (res != null && res != undefined) {
            getActionSocialesDematByCASAndDlg(res.codeDelegation);
          }
        })
      };

    const getActionSocialesDematByCASAndDlg = (codeDelegation) => {
          actionSocialeService.getActionSocialeDematByCASAndDlg(codeCas, codeDelegation).then(
              (response) => {
                Object.values(response.data).map(item => {
                    setListActionSociales(current => [...current, item]);
                })
                setLoadInit(true);
              }
          );
    };


    const initData = () => {
        let count = 0;
        let tmpFilteredList = [];
        Object.values(listActionSociales).forEach(as => {
            if (as.codeActionSociale === codeCas) {
                tmpFilteredList.push(as);
               count++;
            }
        });

        setExercicesList(tmpFilteredList);

        if (count == 1) {
            dispatch(setCAS(codeCas));
            dispatch(setListActionSociale(listActionSociales));
            dispatch(setASExercice(tmpFilteredList[0].exercice));
            setSkip(true);
        }
    };

    return (
        <div className="grid cld-width" style={{marginTop: "1%"}}>
            <ChequeCultureLegacy />
            <div className="col-12 mx-auto">
                <div className="no_shadow_no_border card " style={{display: !displayBasic ? "block" : "none"}}>
                    <nav aria-label="breadcrumb" class="pt-3">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <a href={linkService.getRetourEaAccueilAgent()} target="_self">
                                    Espace Agent
                                </a>
                            </li>

                            <li className="breadcrumb-item">
                                <a href={linkService.getRetourEaMembrePrestation()}
                                   target="_self">
                                    Prestations et Formulaires
                                </a>
                            </li>

                            <li aria-current="page" className="breadcrumb-item active">
                                Demande d'une prestation
                            </li>
                        </ol>
                    </nav>
                    <p></p>
                    <h2
                        className="cld-h2"
                        style={{marginTop: "2%", marginBottom: "2%"}}
                    >
                        La période concernée
                    </h2>
                    <div
                        style={{
                            backgroundColor: "#E9ECEF",
                            paddingLeft: "1%",
                            paddingTop: "1%",
                            paddingBottom: "2%",
                            borderRadius: "5px",
                        }}
                    >
                        <p style={{color: "#000", fontSize: "14px"}}>
                            Ma demande concerne des dépenses effectuées durant l'année
                        </p>
                        {exerciceslist &&
                        exerciceslist.length > 0 &&
                        exerciceslist.map((element) => (
                            <div key={element.exercice} style={{marginTop: "1%"}}>
                                <RadioButton inputId={element.key} name="CAS_RADIO" value={element.exercice}
                                   onChange={(e) => setSelectedExercice(e.value)} checked={selectedExercice === element.exercice} />
                                <b> &nbsp;&nbsp;&nbsp;{element.exercice} </b>
                            </div>
                        ))}
                    </div>
                    {
                        exerciceslist && exerciceslist.length > 0 &&
                        <div className="next-button-wrapper">
                            {
                                selectedExercice
                                    ? <Link to={"/vacances/create"} className="next-button-link"
                                            onClick={actionSocialeService.persistState(actionSociale)}>
                                        <button type="button" className="next-button button-arrow">Etape suivante</button>
                                    </Link>
                                    : <Link to={""} className="next-button-link" style={{ pointerEvents: "none" }}>
                                        <button type="button" className="next-button button-arrow disabled">Etape suivante
                                        </button>
                                    </Link>
                            }
                        </div>
                    }
                </div>
            </div>
        </div>
    );
};
